/* BAGO storefront enhancement. Native Sense handles purchases and checkout. */
(() => {
  if (customElements.get('bago-mobile-nav')) return;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-bago-search')) return;
    const field = form.querySelector('input[type="search"]');
    if (!field) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const term = field.value.trim().replace(/["()\\]/g, ' ');
    const tag = form.dataset.bagoSearch;
    const url = new URL(form.action, window.location.origin);
    const formData = new FormData(form);
    for (const [key, value] of formData) {
      if (typeof value === 'string') url.searchParams.set(key, value);
    }
    url.searchParams.set('q', 'tag:"' + tag + '"' + (term ? ' AND (' + term + ')' : ''));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    window.location.assign(url.toString());
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.menu-drawer a[href]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin === location.origin && target.pathname === location.pathname && target.hash) {
      const drawer = link.closest('header-drawer');
      const trigger = drawer?.querySelector('summary');
      drawer?.closeMenuDrawer(event, trigger);
      trigger?.setAttribute('aria-expanded', 'false');
    }
  });

  class BagoMobileNav extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-action]');
        if (!link) return;
        if (link.dataset.action === 'bag') {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            event.preventDefault();
            drawer.open(link);
          }
        } else if (link.dataset.action === 'search') {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'instant' });
          requestAnimationFrame(() => requestAnimationFrame(() => {
            const trigger = [...document.querySelectorAll('.header__search summary')]
              .find(summary => summary.getClientRects().length > 0);
            if (trigger) trigger.click();
            else window.location.assign(link.href);
          }));
        }
      }, { signal: this.controller.signal });
      this.refresh = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.updateCount(), 120);
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      window.addEventListener('pageshow', this.refresh, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => {
        const nativeCount = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]');
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (nativeCount) this.setCount(Number(nativeCount.textContent));
        else if (!bubble) this.setCount(0);
      });
      const header = document.querySelector('.section-header');
      if (header) this.observer.observe(header, { childList: true, subtree: true, characterData: true });
    }
    setCount(count) {
      if (!Number.isFinite(count)) return;
      this.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(count); el.hidden = count === 0; });
      this.querySelectorAll('[data-cart-description]').forEach(el => { el.textContent = this.dataset.countLabel + ' ' + count; });
    }
    async updateCount() {
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        this.setCount(cart.item_count);
      } catch (error) { /* Keep server-rendered count during offline navigation. */ }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
  }
  customElements.define('bago-mobile-nav', BagoMobileNav);
})();
